import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationService } from '../../services/confirmation.service';
import { DialogFocusDirective } from '../../pixel-game/dialog-focus.directive';

@Component({
  selector: 'app-ui-confirmation-dialog',
  standalone: true,
  imports: [TranslateModule, DialogFocusDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (confirmation.current(); as request) {
      <div class="ui-dialog-backdrop" (click)="confirmation.finish(false)">
        <section class="ui-dialog" role="alertdialog" aria-modal="true" aria-labelledby="confirmation-title"
          aria-describedby="confirmation-message" (click)="$event.stopPropagation()"
          (escapePressed)="confirmation.finish(false)">
          <h2 id="confirmation-title">{{ request.title | translate }}</h2>
          <p id="confirmation-message">{{ request.message | translate:request.messageParams }}</p>
          @if (request.details) { <p class="ui-muted break-words">{{ request.details }}</p> }
          <div class="ui-action-row">
            <button type="button" class="ui-button" (click)="confirmation.finish(false)">{{ 'UI_CANCEL' | translate }}</button>
            <button type="button" class="ui-button ui-danger" (click)="confirmation.finish(true)">{{ (request.confirmLabel || 'UI_CONFIRM_DELETE') | translate }}</button>
          </div>
        </section>
      </div>
    }
  `
})
export class UiConfirmationDialogComponent { readonly confirmation = inject(ConfirmationService); }
